<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_iv"></a><a id="Copyright">First published in 2014 by NewSouth Publishing<br/>
University of New South Wales Press Ltd, University of<br/>
New South Wales, Sydney NSW 2052, Australia.</a></p><a id="Copyright">
<p class="copyright3">Reprinted in this format in 2015 by<br/>
PEN &amp; SWORD AVIATION<br/>
An imprint of<br/>
Pen &amp; Sword Books Ltd<br/>
47 Church Street<br/>
Barnsley, South Yorkshire<br/>
S70 2AS</p>
<p class="copyright3">Copyright © Kristen Alexander 2014, 2015</p>
<p class="copyright3">ISBN: 978 1 47383 379 1<br/>
EPUB ISBN: 978 1 47385 943 2<br/>
PRC ISBN: 978 1 47385 942 5</p>
<p class="copyright3">The right of Kristen Alexander to be identified as Author<br/>
of this work has been asserted by her in accordance<br/>
with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright3">A CIP catalogue record for this book is available from the British Library</p>
<p class="copyright3">All rights reserved. No part of this book may be reproduced or<br/>
transmitted in any form or by any means, electronic or mechanical<br/>
including photocopying, recording or by any information storage and<br/>
retrieval system, without permission from the Publisher in writing.</p>
<p class="copyright3">Typeset by Josephine Pajor-Markus</p>
<p class="copyright3">Printed and bound in England<br/>
By CPI Group (UK) Ltd, Croydon, CR0 4YY</p>
<p class="copyright3">Pen &amp; Sword Books Ltd incorporates the Imprints of Aviation, Atlas,<br/>
Family History, Fiction, Maritime, Military, Discovery, Politics, History,<br/>
Archaeology, Select, Wharncliffe Local History, Wharncliffe True Crime,<br/>
Military Classics, Wharncliffe Transport, Leo Cooper, The Praetorian Press,<br/>
Remember When, Seaforth Publishing and Frontline Publishing</p>
</a><p class="copyright3"><a id="Copyright">For a complete list of Pen &amp; Sword titles please contact<br/>
PEN &amp; SWORD BOOKS LIMITED<br/>
47 Church Street, Barnsley, South Yorkshire, S70 2AS, England<br/>
E-mail: </a><a href="mailto:enquiries@pen-and-sword.co.uk">enquiries@pen-and-sword.co.uk</a><br/>
Website: <a href="http://www.pen-and-sword.co.uk" target="_blank">www.pen-and-sword.co.uk</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Copyright.vue?646c9f60